//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import HouseItem from '@/components/business/house_item'

export default {
    props: {
        item: {
            type: Object
        }
    },
    components: {
       HouseItem
    },
    methods: {
        openBuilding () {
            wx.navigateTo({
                url: this.item.href
            })
        }
    }
}
